import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useNavigation } from '@/components/contexts/NavigationContext';
import { useSidePanel } from '@/components/contexts/SidePanelContext';
import { toolbarContainerClass } from '@/lib/toolbar-compact';
import { getSidePanelAwareRightInset, PANEL_RIGHT_GAP } from '@/lib/nav-constants';
import { cn } from '@/lib/utils';

/** Matches case-files / correspondence `px-6` so this bar is as wide as the table toolbar. */
const PAGE_X_PADDING = 24;

export const BulkActionBar = ({
  children,
  open,
}: {
  children: ReactNode;
  open: boolean;
}) => {
  const { collapsed: navigationCollapsed } = useNavigation();
  const { isOpen: sidePanelOpen, panelWidth } = useSidePanel();

  if (typeof window === 'undefined') return null;

  return createPortal(
    <div
      className={cn(
        'fixed bottom-0 left-6 z-[25] transition-all duration-300 ease-in-out',
        // 80/224 sidebar + 24 page padding — same content box as the table toolbar
        navigationCollapsed ? 'lg:left-[104px]' : 'lg:left-[248px]',
        open ? 'translate-y-0' : 'translate-y-20',
        toolbarContainerClass,
      )}
      style={{
        right: `${PAGE_X_PADDING + (sidePanelOpen ? getSidePanelAwareRightInset(panelWidth, navigationCollapsed) + PANEL_RIGHT_GAP : 0)}px`,
      }}
    >
      <div className="w-full min-w-0 bg-slate-100 outline outline-1 outline-slate-200 p-4 flex items-center justify-between border border-b-0 border-slate-200 rounded-t-lg shadow-s">
        {children}
      </div>
    </div>,
    document.body,
  );
};
